import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./components/HomePage";
import ChargebackPage from "./components/ChargebackPage";
import ChargebacksPage from "./components/ChargebacksPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chargeback" element={<ChargebackPage />} />
          <Route path="/chargeback/" element={<ChargebackPage />} />
          <Route path="/chargebacks" element={<ChargebacksPage />} />
          <Route path="/chargebacks/" element={<ChargebacksPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;